import React from 'react';
import { AuthProvider as OAuth2Provider } from 'react-oauth2-code-pkce';
import getOAuthConfig from '../services/auth/oAuthConfig';
import TokenCookieSync from '../cookies/TokenSync';
import OAuthErrorHandler from './OAuthErrorHandler';

const LoginProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <OAuth2Provider authConfig={getOAuthConfig()}>
      <OAuthErrorHandler />
      {children}
      <TokenCookieSync />
    </OAuth2Provider>
  );
};

export default LoginProvider;
